var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2235 7.70181C17.2235 11.1505 10.7216 19.4744 10.7216 19.4744C10.7216 19.4744 4.21973 11.1505 4.21973 7.70181C4.21973 6.04883 4.90474 4.46355 6.12408 3.29472C7.34342 2.12588 8.9972 1.46924 10.7216 1.46924C12.446 1.46924 14.0998 2.12588 15.3191 3.29472C16.5385 4.46355 17.2235 6.04883 17.2235 7.70181V7.70181Z",
    stroke: "white",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.721 9.77956C11.918 9.77956 12.8883 8.84942 12.8883 7.70203C12.8883 6.55465 11.918 5.62451 10.721 5.62451C9.52404 5.62451 8.55371 6.55465 8.55371 7.70203C8.55371 8.84942 9.52404 9.77956 10.721 9.77956Z",
    stroke: "white",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.646484 0.754883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7c02069458c436fe8978aa0828d1ef8c.svg";
export { ForwardRef as ReactComponent };